/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.EventSchedule {
    "use strict";

    export class EventScheduleContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        private _oldBusinessType: Model.DataDetail;
        public serviceListCriteria: any = {};
        public isBusinessTypeNull: boolean;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
            this.showAllBusinesType = false;
            this.baseEndpoint = appSettings.API_ENDPOINTS.eventSchedule;
            this.sectionTemplatePath = "app/plugins/eventSchedule/sectionViews/";

            this.buildCrudSecurityKeys(this.securityKeys.BUSINESSINFO_EVENTSCHEDULE_TAB_MAIN);
            this.entityType = 'EventSchedule';

            if (this.identityService.inCentralOfficeMode() && Model.Guard.isSomething(this.identityService.current().userBusinessTypeIds)) {

                var _userAssignedBT: Model.DataDetail[] = [];
                var _BT: Model.DataDetail;
                for (const key in this.identityService.current().userBusinessTypeIds) {
                    const value = this.identityService.current().userBusinessTypeIds[key]
                    _userAssignedBT.push({ id: key, displayName: value })

                }
                if (_userAssignedBT.length > 0 ) {
                    this.serviceListCriteria.coBusinessTypeId = _userAssignedBT[0].id;
                    this.serviceListCriteria.coSearchType = Meevo.Model.CoSearchType.CentralOffice;
                }

            }

        }

        initializeSections(): void {
           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_EVENTSCHEDULE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
               this.sections.push(new MainSection(0, "SECTION_BUSINFO_EVENTS", "main.html", true, false, this.appSettings.API_ENDPOINTS.eventSchedule, "",
                   this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.EventsMain, null, this.modalService, this.securityKeys.BUSINESSINFO_EVENTSCHEDULE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
           }
        }

        get allowTakeOwnership(): boolean {
            return false;
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            if (this.identityService.inCentralOfficeMode() && Model.Guard.isSomething(model.businessTypeDetail) && !this.isLocationImpersonating) {
                this.serviceListCriteria.coBusinessTypeId = model.businessTypeDetail.id;
                this.serviceListCriteria.coSearchType = Meevo.Model.CoSearchType.CentralOffice;
                this.isBusinessTypeNull = false;
            }
        }

        savePreviousBusinessTypeDetail(detail): void {
            if (Model.Guard.isSomething(detail))
                this._oldBusinessType = detail;
        }


         onBusinessTypeChange(): void  {
            if (Model.Guard.isSomething(this.selectedSection.model)) {
                let businessTypeDetail = this.selectedSection.model.businessTypeDetail;
                if (this.identityService.inCentralOfficeMode() && Model.Guard.isSomething(businessTypeDetail)) {
                    this.serviceListCriteria.coBusinessTypeId = businessTypeDetail.id;
                    this.serviceListCriteria.coSearchType = Meevo.Model.CoSearchType.CentralOffice;
                }
                if (Model.Guard.isNothing(this._oldBusinessType))
                    this.savePreviousBusinessTypeDetail(businessTypeDetail);

                if (businessTypeDetail && Model.Guard.isSomething((<Meevo.Model.EventSchedule>this.selectedSection.model).services) &&
                    (<Meevo.Model.EventSchedule>this.selectedSection.model).services.length > 0) {
                    this.modalService.confirmHandler("MESSAGE_MODAL_BUSINESS_TYPE_CHANGE_SERVICES", Components.Modal.ModalTranslationModes.Translate)
                        .then((res: boolean) => {
                            if (res) {
                                (<Meevo.Model.EventSchedule>this.selectedSection.model).services.length = 0;
                            } else {
                                this.selectedSection.model.businessTypeDetail = this._oldBusinessType;
                                this.serviceListCriteria.coBusinessTypeId = this._oldBusinessType.id;
                            }
                        });
                }
                if (Model.Guard.isNothing(this.selectedSection.model.businessTypeDetail)) {
                    this.isBusinessTypeNull = true;
                } else {
                    this.isBusinessTypeNull = false;
                }
            }
        }

        isServiceDisabled(): boolean {

            if (Model.Guard.isNothing(this.selectedSection.model)) {
                return true;
            }
            
            if ((this.identityService.inCentralOfficeMode() && this.identityService.current().tenantBusinessTypeCount != 1) && (Model.Guard.isNothing(this.selectedSection.model.businessTypeDetail) || _.isEmpty(this.selectedSection.model.businessTypeDetail) || this.isBusinessTypeNull)) {
                    return true;
                }
                else if (this.isReadonly || !this.isAccessible) {
                    return true;
                }
                else {
                    return false;

                }
        }
      
        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.EventSchedule>();
            model.displayName = undefined;
        }

        autoExclusionWarning(model: any): void {

            if (this.identityService.inCentralOfficeMode() && (<Meevo.Model.EventSchedule>model).hasAutoExclusions)
                this.modalService.warning("Your event has been saved successfully, please check your location exlusions. <br /> Some locations were automatically excluded from this event due to overlap with an existing events at the location.");
        }

        postAdd(model: any): void {

             super.postAdd(model);

            this.autoExclusionWarning(model);

        }

        postUpdate(model: any): void {
            super.postUpdate(model);

            this.autoExclusionWarning(model);
        }

    }
}